
Vue.component('carousel', require('./components/Carousel.vue'));
Vue.component('modal-box', require('./components/ModalBox.vue'));
Vue.component('menu-item', require('./components/MenuItem.vue'));
Vue.component('pull-down', require('./components/PullDown.vue'));
Vue.component('accordion', require('./components/Accordion.vue'));
Vue.component('google-map', require('./components/GoogleMap.vue'));
Vue.component('google-map-notaries-collaborators', require('./components/GoogleMapNotariesCollaborators.vue'));
Vue.component('tab-toggle', require('./components/TabToggle.vue'));
Vue.component('burger-menu', require('./components/BurgerMenu.vue'));
Vue.component('modal-alert', require('./components/ModalAlert.vue'));
Vue.component('page-loader', require('./components/PageLoader.vue'));
Vue.component('site-search', require('./components/SiteSearch.vue'));
Vue.component('tabbed-menu', require('./components/TabbedMenu.vue'));
Vue.component('tab-content', require('./components/TabContent.vue'));
Vue.component('close-button', require('./components/CloseButton.vue'));
Vue.component('marker-place', require('./components/MarkerPlace.vue'));
Vue.component('menu-subitem', require('./components/MenuSubitem.vue'));
Vue.component('accordion-item', require('./components/AccordionItem.vue'));
Vue.component('checklist-item', require('./components/ChecklistItem.vue'));
Vue.component('contact-dialog', require('./components/ContactDialog.vue'));
Vue.component('contact-notaries-dialog', require('./components/ContactNotariesDialog.vue'));
Vue.component('urgency-dialog', require('./components/UrgencyDialog.vue'));
Vue.component('store-tariff-dialog', require('./components/StoreTariffDialog.vue'));
Vue.component('cookies-advise', require('./components/CookiesAdvise.vue'));
Vue.component('navigation-bar', require('./components/NavigationBar.vue'));
Vue.component('overlayed-image', require('./components/OverlayedImage.vue'));
Vue.component('team-department', require('./components/TeamDepartment.vue'));
Vue.component('tabbed-menu-item', require('./components/TabbedMenuItem.vue'));
Vue.component('background-image', require('./components/BackgroundImage.vue'));
Vue.component('navigation-title', require('./components/NavigationTitle.vue'));
Vue.component('unavailable-link', require('./components/UnavailableLink.vue'));
Vue.component('google-map-markers', require('./components/GoogleMapMarkers.vue'));
Vue.component('contact-area-button', require('./components/ContactAreaButton.vue'));
Vue.component('navigation-bar-menu', require('./components/NavigationBarMenu.vue'));
Vue.component('customer-area-button', require('./components/CustomerAreaButton.vue'));
Vue.component('header-menu-background', require('./components/HeaderMenuBackground.vue'));
Vue.component('shared-height-container', require('./components/SharedHeightContainer.vue'));
Vue.component('datetime', require('./components/datetimepicker/Datetime.vue'));
Vue.component('budget-summary', require('./components/budgetary/BudgetSummary.vue'));
Vue.component('numeric-question', require('./components/budgetary/NumericQuestion.vue'));
Vue.component('assertive-question', require('./components/budgetary/AssertiveQuestion.vue'));
Vue.component('legitimation-document', require('./components/budgetary/legitimations/LegitimationDocument.vue'));
Vue.component('legitimations-budgetary', require('./components/budgetary/legitimations/LegitimationsBudgetary.vue'));
Vue.component('policies-budgetary', require('./components/budgetary/policies/PoliciesBudgetary.vue'));
Vue.component('testimonials-budgetary', require('./components/budgetary/testimonials/TestimonialsBudgetary.vue'));
Vue.component('testimonials-document', require('./components/budgetary/testimonials/TestimonialsDocument.vue'));
Vue.component('tour-virtual', require('./components/TourVirtual.vue'));
Vue.component('social-media-buttons', require('./components/SocialButtons.vue'));



// WEBPACK FOOTER //
// ./resources/assets/js/components.js